import React from 'react';

const CopyrightText: React.FC = () => {
  return (
    <div className="delete-account-footer-text">©2025 AiCourses. All rights reserved.</div>
  );
};

export default CopyrightText;
